import { getPromise } from "./request-promise";

export interface DashboardLicenseResponse {
	isValidLicense: boolean;
}

export function getStrayosDashboardLicense(userId: number) {
	return getPromise<DashboardLicenseResponse>(`api/v1/user_licenses/get_strayos_dashboards_license?user_id=${userId}`, data => data ?? null);
}
